function ToggleMegaMenu(code) {

    var onlyHide = $("#megamenu" + code).hasClass("megamenu-active");
    //hide current active
    $(".megamenu-active").slideUp();
    $(".megamenu-active").removeClass("megamenu-active");
    $('body').css({ overflow: onlyHide ? 'auto' : 'hidden', width: '100%', height: '100%' });

    // set active class
    if (!onlyHide) {
        $("#megamenu" + code).toggleClass("megamenu-active");

        // Show mega menu
        $("#megamenu" + code).slideToggle();

        if (code == 'search') {
            //set focus
            $('#search').focus();
        }
    } 
    /* */

    // Hide page behind transparent black overlay
    var hasActiveClass = $("#megamenu" + code).hasClass("megamenu-active");
    if (hasActiveClass == true && onlyHide == false) {
        $(".overlay").addClass("overlay-active");
        if (code == "search") {
            $("#megamenusearch form input#q").focus();
        }
    } else {
        $(".overlay").removeClass("overlay-active");
    }
}





function findBootstrapEnvironment() {
    var envs = ['xs', 'sm', 'md', 'lg'];

    var $el = $('<div>');
    $el.appendTo($('body'));

    for (var i = envs.length - 1; i >= 0; i--) {
        var env = envs[i];

        $el.addClass('hidden-' + env);
        if ($el.is(':hidden')) {
            $el.remove();
            return env;
        }
    }
}

function isMobile() {
    return findBootstrapEnvironment() === 'xs';
}

function swipedetect(el, callback) {
    var touchsurface = el,
    swipedir,
    startX,
    startY,
    distX,
    distY,
    threshold = 75,
    restraint = 100,
    allowedTime = 300,
    elapsedTime,
    startTime,
    handleswipe = callback || function (swipedir) { };

    touchsurface.addEventListener('touchstart', function (e) {
        var touchobj = e.changedTouches[0];
        swipedir = 'none';
        dist = 0;
        startX = touchobj.pageX;
        startY = touchobj.pageY;
        startTime = new Date().getTime();
    }, false)

    touchsurface.addEventListener('touchmove', function (e) {
        e.preventDefault();
    }, false)

    touchsurface.addEventListener('touchend', function (e) {
        var touchobj = e.changedTouches[0];
        distX = touchobj.pageX - startX;
        distY = touchobj.pageY - startY;
        elapsedTime = new Date().getTime() - startTime;
        if (elapsedTime <= allowedTime) {
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
                swipedir = (distX < 0) ? 'left' : 'right';
            }
            else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
                swipedir = (distY < 0) ? 'up' : 'down';
            }
        }
        handleswipe(swipedir);
    }, false)
}

var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
        e.preventDefault();
    e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

function disableScroll() {
    if (window.addEventListener) // older FF
        window.addEventListener('DOMMouseScroll', preventDefault, false);
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    window.ontouchmove = preventDefault; // mobile
    document.onkeydown = preventDefaultForScrollKeys;
}

function enableScroll() {
    if (window.removeEventListener)
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
}

//function ToggleMegaMenuBikes() {

//    HideHeaderSliders("bikes");

//    // set actuve class
//    $("#megamenuBikes").toggleClass("megamenu-active");

//    // Show mega menu
//    $("#megamenuBikes").slideToggle();

//    // Hide page behind transparent black overlay
//    var hasActiveClass = $("#megamenuBikes").hasClass("megamenu-active");
//    if (hasActiveClass == true) {
//        $(".overlay").addClass("overlay-active");
//    } else {
//        $(".overlay").removeClass("overlay-active");
//    }
//}

//function ToggleMegaMenuGear() {

//    HideHeaderSliders("gear");

//    $("#megamenuGear").toggleClass("megamenu-active");

//    // Show mega menu
//    $("#megamenuGear").slideToggle();

//    // Hide page behind transparent black overlay
//    var hasActiveClass = $("#megamenuGear").hasClass("megamenu-active");
//    if (hasActiveClass == true) {
//        $(".overlay").addClass("overlay-active");
//    } else {
//        $(".overlay").removeClass("overlay-active");
//    }

//}


//function HideHeaderSliders(itemNotToHide) {
//    if (itemNotToHide != "bikes") {
//        $("#megamenuBikes").slideUp();
//        $("#megamenuBikes").removeClass("megamenu-active");
//    }

//    if (itemNotToHide != "gear") {
//        $("#megamenuGear").slideUp();
//        $("#megamenuGear").removeClass("megamenu-active");
//    }

//    if (itemNotToHide != "search") {
//        $("div#searchbar").slideUp();
//    }
//}



// www.stackoverflow.com/a/7557433/533460
function isElementInViewport(el) {

    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
}


function HandleScrollMenuClick() {
    // anchor click
    $("div.scrollmenu a").click(function (event) {

        // prevent anchor link
        event.preventDefault();

        // set link state
        $("div.scrollmenu a").removeClass("active");

        var linkId = this.id;
        $("div.scrollmenu a#" + linkId).addClass("active");

        // scroll
        myHref = $(this).attr("href");
        ScrollToTarget(myHref);
    });
}


function ScrollToTarget(myHref) {

    minusPixels = 165;
    if ($("body").hasClass("liv")) {
        minusPixels = 185;
    }

    var target = $(myHref);
    if (target.length) {
        var newPosition = target.offset().top;
        newPosition = newPosition - minusPixels;
        $('html, body').animate({
            scrollTop: newPosition
        }, 1000);
    }
}

function HandleScrollMenuState() {
    // window scrolling
    $(window).scroll(function () {

        $(".scrollmenu-target").each(function () {
            var myId = this.id
            var isVisible = isElementInViewport(this);
            //if (isVisible == true) {
            //    $("div.scrollmenu a").removeClass("active");
            //    $("a#scrollmenu-" + myId).addClass("active");
            //}
        });

    });
}



function HandleScrollHeaderAndBrandSwitch(myObject) {

    var distanceToTop = $(myObject).scrollTop();
    var isMobileVersion = $(".hamburger").is(':visible');

    // header transparency + back to top link
    if (distanceToTop > 100) {
        $("header").addClass("not-transparent");
        $(".backtotop").addClass("backtotop-visible");
    }
    else {
        $("header").removeClass("not-transparent");
        $(".backtotop").removeClass("backtotop-visible");
    }
    // brandswitch
    if (isMobileVersion == true) {  // or (distanceToTop > 100)
        $("body").addClass("brandswitch-hidden");
    }
    else {
        $("body").removeClass("brandswitch-hidden");
    }

}




/* on mobile devices no parallax please */

function HandleParallaxBanners() {
    $(".parallax").each(function () {

        windowSize = $(window).width();
        dataBackgroundSrc = $(this).attr("data-background-src");
        if (windowSize <= 1024) {
            $(this).css("background-image", "url('" + dataBackgroundSrc + "')");
            $(this).addClass("parallax-background-mode");
        } else {
            $(this).css("background-image", "");
            $(this).removeClass("parallax-background-mode");
        }

    });
}

function HandleRiderSpecs() {
    nrOfRows = $("#specs table tr").length;
    halfWay = Math.ceil((nrOfRows / 3) * 2);
    index = 1;
    firstHalf = "";
    secondHalf = "";

    $("#specs table tr").each(function () {

        if (index <= halfWay) {
            firstHalf += "<tr>" + $(this).html() + "</tr>";
        } else {
            secondHalf += "<tr>" + $(this).html() + "</tr>";
        }
        index++;
    });

    $("#rider-table-left").append("<table>" + firstHalf + "</table>");
    $("#rider-table-right").append("<table>" + secondHalf + "</table>");

}

function HandleSpecificationsTable() {
    nrOfRows = $("#specifications table.specifications tr").length;
    halfWay = Math.ceil(nrOfRows / 2);

}


function hasValidSizeColorUsage() {
    // color
    var colorValue = $("select#colorSelector").val();
    var checkForColor = false;
    if ($("#colorSelector").length) {
        checkForColor = true;
    }
    // size
    var hasSizeValue = false;
    if (($("a.selected-size").length) || ($("#oneSize").length)) {
        hasSizeValue = true;
    }
    // usage
    var checkForUsage = false;
    if ($("#usageSelector").length) {
        checkForUsage = true;
    }
    var hasUsageValue = false;
    if ($("a.selected-size").length) {
        hasUsageValue = true;
    }

    if (checkForUsage == true && hasUsageValue == false) {
        $(".select-usage-alert").show().delay(2000).fadeOut("slow");
        return false;
    } else if (checkForColor == true && colorValue == "") {
        $(".select-color-alert").show().delay(2000).fadeOut("slow");
        return false;
    } else if (hasSizeValue == false) {
        $(".select-size-alert").show().delay(2000).fadeOut("slow");
        return false;
    } else {
        return true;
    }
}




function HandleProductColorAndSizeData(objColorSelect) {

    /* HANDLE PRODUCT COLOR AND SIZE DATA */

    if ($("#colorSelector").length) {

        // get color value
        colorValue = objColorSelect.value;

        if (colorValue != "") {

            // remove whitespaces and slashes
            colorValue = colorValue.replace(/\s/g, '');
            colorValue = colorValue.replace(/\//g, '');

            if ($("#oneSize").length) {
                // ONE SIZE so no size onclick event

                // get partnumber
                dataPartnumberCode = $("select#colorSelector").children(":selected").attr("data-partnumbercode");

                // remove all spans
                $("span.stock-info-one-size").hide();

                //console.log("oneSize, colorValue: " + colorValue);

                // show stock for color
                $("div#oneSize span#color-" + colorValue).show();

                // handle buttons
                HandleButtonsForPartnumber(dataPartnumberCode)

            }
            else
            {

                // remove input value to prevent invalid color size combinations
                CleanSizeData();

                // first hide all
                $("ul#sizeSelector li").hide();

                // show all with color
                $("ul#sizeSelector li").each(function () {
                    liID = this.id;
                    liDataColorName = $(this).attr("data-colorname");
                    colorValueToCheck = "color-" + colorValue;

                    // console.log("colorValueToCheck: " + colorValueToCheck);

                    if ((liDataColorName == colorValueToCheck)) {
                        // show sizes for color
                        $("ul#sizeSelector li#" + liID).show();
                    }
                });

                // remove disabled attr and disabled class
                $("button#sizeSelectButton").removeAttr('disabled');
                $("#styled-select-size").removeClass('styled-select-disabled');

            }
        }
        else {
            // no color value -> disable sizes
            CleanSizeData();
        }
    }
    else if ($("#oneColor").length) {
        if ($("#oneSize").length) {
            //console.log("one color AND one size");

            var dataPartnumberCode = $("#oneSize").attr("data-partnumbercode");

            // show stock for one size one color
            $("span.stock-info-one-size").show();

            // handle buttons
            HandleButtonsForPartnumber(dataPartnumberCode)
        }
        else {
            //console.log("one color MULTIPLE sizes");
        }

    }
}


function HandleSizeClick(objLink) {
    // get value
    var dataPartnumberCode = $(objLink).attr("data-partnumbercode");

    // get size html
    var sizeHtml = $(objLink).html();
    // change button label
    $("button#sizeSelectButton").html(sizeHtml);

    // set active class
    $("ul#sizeSelector li a").removeClass("selected-size");
    $(objLink).addClass("selected-size");
    // handle buttons
    HandleButtonsForPartnumber(dataPartnumberCode)
}


function HandleButtonsForPartnumber(dataPartnumberCode) {
    // handle buttons
    $('.action').hide();
    $('#action-' + dataPartnumberCode).show();
}

function CleanSizeData() {
    // empty size value
    $("input#size").val("");
    // remove selected size classes
    $("ul#sizeSelector li a").removeClass("selected-size");
    // change button label
    $("button#sizeSelectButton").text("Select size");
    // disabled
    $("button#sizeSelectButton").attr('disabled', 'disabled');
    // ghosted
    $("#styled-select-size").addClass('styled-select-disabled');
}


function checkIfAddToCartButtonIsThereAndDoStuff() {
    if ($("button.btn-addtocart").length) {
        $("form#clickandcollect").addClass("has-add-to-cart-button");
    } else {
        $("form#clickandcollect").removeClass("has-add-to-cart-button");
    }
}


function ShowCartSummary() {
    function implement(data, noSlide) {
        $('.cart-summary-popup .body').html(data);

        if (noSlide !== true) {
            $('.cart-summary-popup').slideDown();
            $('body').on('click', function (e) {
                if ($(e.target).parents('.cart-summary-popup').length == 0) {
                    $('.cart-summary-popup').slideUp();
                    $('body').unbind(e);
                }
            });
        }

        $('.remove-cart-item').on('click', function (e) {
            $.getJSON('/' + culture + '/shop/removecartitem/' + $(this).data('partnumber') + '/json', {
                cache: false
            }, function (data) {
                if (data.CartQuantity > 0) {
                    $('.remove-cart-item').off('click');
                    $('#summary-NumberOfItems, .NumberOfItems')
                        .html(data.CartQuantity);
                    $('#summary-NumberOfItemsLabel').html(data.CartQuantity > 1 ? 'items' : 'items');
                    $('#summary-total').html(data.CartTotal);
                    $('.cart-summary-container').removeClass('cart-summary-empty');
                    implement(data.Html, true);
                } else {
                    $('.cart-summary-popup').slideUp();
                    $('.cart-summary-container').addClass('cart-summary-empty');
                    $('#summary-NumberOfItems, .NumberOfItems').html(0);
                    $('#summary-NumberOfItemsLabel').html('');
                    $('a.cart-summary-container').removeAttr('href');
                    $('#summary-total').html('');
                }
            });
        });

        $('.update-cart-item').on('click', function (e) {
            var quantity = parseInt($('#cartItem-' + $(this).data('partnumber') + ' .cartItem-quantity').html());
            if ($(this).data('update') == 'plus') {
                quantity = 1;
            } else {
                quantity = -1;
            }
            //if (quantity > 0) {
                $.ajax({
                    type: 'POST',
                    url: '/' + culture + '/shop/updatecartitem',
                    data: { partnumberCode: $(this).data('partnumber'), modelId: $(this).data('modelid'), productType: $(this).data('producttype'), quantity: quantity },
                    success: function (data) {
                        $('#summary-NumberOfItems, .NumberOfItems').html(data.CartQuantity);
                        $('#summary-NumberOfItemsLabel').html(data.CartQuantity > 1 ? 'items' : 'items');
                        $('#summary-total').html(data.CartTotal);
                        $('.cart-summary-container').removeClass('cart-summary-empty');
                        implement(data.Html, true);
                    }
                });
            //}
        });
    }

    //get cart table realtime
    if ($('.cart-summary-popup').is(':visible')) {
        $('.cart-summary-popup').slideUp();
    } else {
        $.ajax({
            type: 'GET',
            url: '/' + culture + '/shop/getcartTable',
            cache: false,
            success: implement
        });
    }
}

function AddCartItem(productId, partnumberCode, productType, quantity, dealerCode, continueShoppingUrl, extraLabel, globalCatalogue) {
    $.ajax({
        type: 'POST',
        url: '/' + culture + '/shop/addcartitem',
        data: { productId: productId, partnumberCode: partnumberCode, productType: productType, quantity: quantity, dealerCode: dealerCode, globalCatalogue: globalCatalogue },
        success: function (data) {
            //if ($('#cart-table').length == 0) {
            if (data.result > 0) {
                $('#ModalLocalStockFinder').modal('hide');
                if (data.shoplink != undefined && data.shoplink.length > 0) {
                    $('#proceedCheckout').attr('href', data.shoplink);
                }
                $('#cartModal .modal-body').load('/' + culture + '/shop/cartitemadded?cartItemId=' + data.result, function (_d) {
                    if (continueShoppingUrl != undefined && continueShoppingUrl.length > 0) {
                        $('#continueShopping').attr('href', continueShoppingUrl);
                        $('#continueShopping').removeAttr('data-dismiss');
                    }
                    $('#cartModal').modal('show');
                    AnalyticsBuilder.create(inTestMode ? { debug: true } : {}).addProduct({
                        'id': partnumberCode,
                        'name': $('#cartModal').find('.productname').text(),
                        'quantity': quantity
                    }).asAddToCart().send({
                        label: extraLabel && extraLabel.length ? extraLabel : 'Add to cart'
                    });
                });
                UpdateCartSummary();
            }
            else {
                alert(data.exceptionmessage);
            }
        }
    });
}

function UpdateCartSummary() {
    $.ajax({
        type: 'GET',
        url: '/' + culture + '/shop/getcartsummary',
        cache: false,
        success: function (data) {
            $('#summary-NumberOfItems, .NumberOfItems').html(data.NumberOfCartItems);
            $('#summary-NumberOfItemsLabel').html(data.NumberOfCartItems > 1 ? 'items' : 'item');
            $('#summary-total').html(data.TotalToFormat);
            if (data.NumberOfCartItems > 0) {
                $('.cart-summary-container').removeClass('cart-summary-empty');
            } else {
                $('.cart-summary-container').addClass('cart-summary-empty');
            }
            $('#summary-container').fadeIn();
        }
    });
}

//function UpdateCart(includeValidation, callback) {
//    if (includeValidation == undefined) {
//        includeValidation = false;
//    }
//    $.ajax({
//        type: 'GET',
//        url: '/' + culture + '/shop/getcart?includeValidation=' + includeValidation,
//        cache: false,
//        success: function (data) {
//            if (data.NumberOfCartItems == 0) {
//                //remove table
//                $('#cart-table').remove();
//                $('#cart-empty').fadeIn();
//            } else {
//                $('.cart-total').html(data.TotalIncludingShippingCostsToFormat);
//                $('.cart-tax').html(data.TaxToFormat);
//                $('.shipping-total').html(data.ShippingToFormat);
//            }

//            if (document.getElementsByClassName("affirm-learn-more").length > 0) {
//                //update Affirm value
//                updateAffirmAsLowAs(document.getElementsByClassName("affirm-learn-more")[0], data.TotalIncludingShippingCosts * 100);
//            }

//            //Set shipping options
//            data.ShippingOptions.forEach(function (item) {
//                if (item.Guid == data.ShippingGuid) {
//                    $('#shippingLabel').html(item.Name);
//                }
//            });

//            //Set discount
//            if (data.Discount > 0) {
//                $('.cart-discount').html(data.DiscountToFormat);
//                $('.discountContainer').show();
//            } else {
//                $('.discountContainer').hide();
//            }

//            if (callback) {
//                callback();
//            }
//        }
//    });
//}

//function UpdateCartItem(cartItemId) {
//    $.ajax({
//        type: 'GET',
//        url: '/' + culture + '/shop/getcartitem?id=' + cartItemId,
//        success: function (data) {
//            var tr = $('tr#cartItem-' + cartItemId);
//            tr.find('.cartItem-quantity').html(data.Quantity);
//            tr.find('.cartItem-total').html(data.TotalToFormat);

//            if (data.Quantity == 0) {
//                //remove cart item, because quantity is 0
//                RemoveCartItem(cartItemId);
//            }
//        }
//    });
//}

//function SetShippingOption(shippingOption) {
//    var shippingOptionType = $('#' + shippingOption).attr('data-deliverytype');
//    $.ajax({
//        type: 'POST',
//        url: '/' + culture + '/shop/setshippingoption',
//        data: { guid: shippingOption },
//        success: function (data) {
//            if (shippingOptionType == 'homedelivery' && localstock == false && $('#dealerSelected').length > 0 && $('#dealerSelected').val() == 'true') {
//                //remove dealer when switching to homedelivery and not local stock
//                window.location = '/' + culture + '/shop/removedealercode';
//            }
//            UpdateCart();
//            //CheckToGetDealers();
//        }
//    });
//}

//function SetPaymentOption(paymentOption) {
//    $.ajax({
//        type: 'POST',
//        url: '/' + culture + '/shop/setpaymentoption',
//        data: { code: paymentOption },
//        success: function (data) {
//            //UpdateCart();
//        }
//    });
//}

//function SetState(state) {
//    $.ajax({
//        type: 'POST',
//        url: '/' + culture + '/shop/setstate',
//        data: { state: state },
//        success: function (data) {
//            UpdateCart();
//        }
//    });
//}

//function Login(email, password) {
//    $('#loginModal').find('.alert').remove();
//    $.ajax({
//        type: 'POST',
//        url: '/' + culture + '/shop/login',
//        data: { email: email, password: password },
//        success: function (data) {
//            var showErrorMessage = true;
//            for (var property in data) {
//                if (data[property] != null && data[property] != 0) {
//                    showErrorMessage = false;
//                    $('input[name="Order.' + property + '"]').val(data[property]);
//                    $('select[name="Order.' + property + '"]').val(data[property]);
//                }
//            }
//            if (showErrorMessage) {
//                $('#loginModal .modal-body').prepend('<div class="alert alert-danger">No user found</div>');
//            } else {
//                $('#loginModal').modal('hide');
//                //show different delivery address if specified
//                if ($('input[name="Order.OrderDeliveryStreet"]').length > 0) {
//                    $('#deliveryAddressContainer').show();
//                    $('#lnkShowDifferentDeliveryAdress').remove();
//                }
//                //rename create account label
//                $('#lnkCreateAccount').html('Change password');
//                //CheckToGetDealers();
//            }
//        }
//    });
//}

//function CheckToGetDealers() {
//    if ($('#dealerList').length > 0 && $('#Order_OrderStreet').val().length > 0 && $('#Order_OrderPostalcode').val().length > 0 && $('#Order_OrderCity').val().length > 0) {
//        //get list of dealers when there is no directshipment and naw data is filled.
//        var address = country + ', ' + $('#Order_OrderStreet').val() + ', ' + $('#Order_OrderPostalcode').val() + ', ' + $('#Order_OrderCity').val();

//        GetDealers(address, function (data) {
//            var dealerList = $('#dealerList');
//            dealerList.html('');
//            if (data.length > 0) {
//                var result = '<ul style="list-style:none;padding-left:0;">';
//                var checked = 'checked="checked"';
//                data.forEach(function (item) {
//                    result += '<li><input id="' + item.Code + '" name="Order.OrderDealercode" type="radio" value="' + item.Code + '" ' + checked + '/><label style="margin-left:10px;" class="" for="' + item.Code + '">' + item.Name + '</label><p style="padding-left:22px;">' + item.Street + ', ' + item.Zipcode + ', ' + item.City + ' (' + item.DistanceToFormat + ' ' + measurement + ')</p>' + '</li>';
//                    checked = '';
//                });
//                result += '</ul>';
//                dealerList.append(result);
//            } else {
//                dealerList.append('<div class="alert alert-danger">No dealer found. Select a different shipping option.</div>');
//            }
//        }, function () {
//            var dealerList = $('#dealerList');
//            dealerList.html('');
//            dealerList.append('<div class="alert alert-danger">No dealer found. Select a different shipping option.</div>');
//        });
//    }
//}

//function GetDealers(address, callback, callbackError) {
//    getLatLng(address, function (lat, lng, formatted_address) {
//        if (lat != undefined) {
//            $.ajax({
//                type: 'POST',
//                url: '/' + culture + '/shop/dealers',
//                data: { latitude: lat, longitude: lng },
//                success: function (data) {
//                    if (typeof callback === 'function') {
//                        callback.apply(null, [data]);
//                    }
//                },
//                error: function (e) {
//                    if (typeof callbackError === 'function') {
//                        callbackError.apply();
//                    }
//                }
//            });
//        } else {
//            if (typeof callbackError === 'function') {
//                callbackError.apply();
//            }
//        }
//    });
//}






function getAddressFromGoogle() {
    var address = $("#Keyword").val() + ' ' + country;
    address = address.replace(',', '');
    var $latLng = $("#LatLng");
    var $formattedAddress = $("#FormattedAddress");

    // Get lat/lng value, add it to the hidden LatLng field and submit the form
    getLatLng(address, function (lat, lng, formatted_address) {
        if (lat != undefined && lng != undefined) {
            $latLng.val(lat + ',' + lng);
        } else {
            $latLng.val('');
        }
        $formattedAddress.val(formatted_address);
        readyToSubmit = true;
        $("form#Geocoder").submit();
    });
}

// this function takes two parameters
// the address as a string from the input field
// and a callback it will invoke with the results
// when it's done
function getLatLng(address, callback) {

    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({ 'address': address }, function (results, status) {
        var lat, lng, formatted_address;
        if (status == google.maps.GeocoderStatus.OK) {

            // Get the Lat. and Long.
            lat = results[0].geometry.location.lat();
            lng = results[0].geometry.location.lng();
            formatted_address = results[0].formatted_address;
        //} else {
        //    Raygun.send("Google Maps Geocoder exception. Status: " + status);
        }

        // Pass latLng to callback function
        if (typeof callback === 'function') {
            callback.apply(null, [lat, lng, formatted_address, results]);
        }
    });
}

function getBrowserLocation(callback) {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            if (callback) {
                callback(position);
            }
        });
    } else {
        x.innerHTML = "Geolocation is not supported by this browser.";
    }
}


function setImageResizeModeForCarousel(elementId)
{
    $("#carousel-resizemode-placeholder img").each(function () {

        var referenceClass = $(this).attr("data-reference-class");
        var loopSrc = $(this).attr("src");

        var tmpImg = new Image();
        tmpImg.src = loopSrc;
      
        $(tmpImg).one('load', function () {
            orgWidth = tmpImg.width;
            orgHeight = tmpImg.height;
            // if portrait
            if (orgHeight >= orgWidth) {

                // get real li of carousel
                objLi = $(elementId + " ul li."+ referenceClass);
                backgroundImage = $(objLi).css('background-image');
                newBackgroundImage = backgroundImage.replace("mode=crop", "mode=pad");
                // change it now
                $(objLi).css('background-image', newBackgroundImage);
            }

        });

    });


 
}


function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
}

$.fn.optVisible = function (show) {
    if (show) {
        this.filter("span > option").unwrap();
    } else {
        this.filter(":not(span > option)").wrap("<span>").parent().hide();
    }
    return this;
}

var Payeezy = function () {
    function e(e) {
        var t = {
            visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
            mastercard: /^5[1-5][0-9]{14}$/,
            amex: /^3[47][0-9]{13}$/,
            diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
            discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
            jcb: /^(?:2131|1800|35\d{3})\d{11}$/
        };
        for (var n in t) {
            if (t[n].test(e)) {
                return n
            }
        }
    }

    function t() {
        var e = [];
        var t = document.getElementsByTagName("input");
        var n = document.getElementsByTagName("select");
        for (i = 0; i < t.length; i++) {
            var r = t[i];
            var s = r.getAttribute("payeezy-data");
            if (s) {
                e[s] = r.value
            }
        }
        for (i = 0; i < n.length; i++) {
            var r = n[i];
            var s = r.getAttribute("payeezy-data");
            if (s) {
                e[s] = r.value
            }
        }
        return e
    }
    return {
        createToken: function (e) {
            var n = (window.inTestMode != undefined && window.inTestMode) || (window.isDeveloperMachine != undefined && window.isDeveloperMachine) ? "api-cert.payeezy.com" : "api.payeezy.com"; //tijdelijk altijd naar live. Was: "api-cert.payeezy.com"
            this["clientCallback"] = e;
            var r = t();
            var i = 0;
            var s = {};
            var o = 0;
            var u = [];
            if (!this.apikey) {
                i = 400;
                u[o] = {
                    description: "Please set the API Key"
                };
                o++
            }
            if (!this.js_security_key) {
                i = 400;
                u[o] = {
                    description: "Please set the js_security_key"
                }
            }
            if (!this.ta_token) {
                i = 400;
                u[o] = {
                    description: "Please set the ta_token"
                }
            }
            if (!this.auth) {
                i = 400;
                u[o] = {
                    description: "Please set auth value"
                }
            }
            if (u.length > 0) {
                s["error"] = {
                    messages: u
                };
                e(i, s);
                return false
            }
            var a = "https://" + n + "/v1/securitytokens?apikey=" + this.apikey + "&js_security_key=" + this.js_security_key + "&callback=Payeezy.callback&auth=" + this.auth + "&ta_token=" + this.ta_token + "&type=FDToken&credit_card.type=" + r["card_type"] + "&credit_card.cardholder_name=" + r["cardholder_name"] + "&credit_card.card_number=" + r["cc_number"] + "&credit_card.exp_date=" + r["exp_month"] + r["exp_year"] + "&credit_card.cvv=" + r["cvv_code"] + "&currency=" + r["currency"] + "&billing_address.city=" + r["city"] + "&billing_address.country=" + r["country"] + "&billing_address.email=" + r["email"] + "&billing_address.phone.type=" + r["type"] + "&billing_address.phone.number=" + r["number"] + "&billing_address.street=" + r["street"] + "&billing_address.state_province=" + r["state_province"] + "&billing_address.zip_postal_code=" + r["zip_postal_code"];
            var f = document.createElement("script");
            f.src = a;
            document.getElementsByTagName("head")[0].appendChild(f)
        },
        setApiKey: function (e) {
            this["apikey"] = e
        },
        setJs_Security_Key: function (e) {
            this["js_security_key"] = e
        },
        setTa_token: function (e) {
            this["ta_token"] = e
        },
        setAuth: function (e) {
            this["auth"] = e
        },
        setCurrency: function (e) {
            this["currency"] = e
        },
        callback: function (e) {
            this["clientCallback"](e.status, e.results)
        }
    }
}();

// global and country event tracker
function trackEventGlobalAndLocal(evtCat, evtAction, evtLabel) {
    var preferences = window.GDPRactive == true && window.Cookies.get("cookieControlPrefs") != undefined ? $.gdprcookie.preference() : false;
    if (window.GDPRactive == false || (preferences != false && preferences.indexOf('marketing') > -1)) {
        ga('global.send', 'event', evtCat, evtAction, evtLabel);
        ga('CountryTracker.send', 'event', evtCat, evtAction, evtLabel);
        console.log("*GDPR-marketing: Google Adwords Event tracker");
    }
}

function exceptionHandling(message, extra) {
    $.ajax({
        type: 'POST',
        url: '/api/exception',
        data: { message: message, url: window.location.href, extra: extra }
    });
}
